import React from 'react';
import { motion } from 'framer-motion';
export function Section2() {
  return <motion.section initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6
  }} viewport={{
    once: true
  }} className="bg-gray-50 py-16" data-id="element-47">
      <div className="max-w-3xl mx-auto px-6" data-id="element-48">
        <h2 className="font-sans font-bold text-3xl text-[#0F4226] mb-8" data-id="element-49">
          2. The Fall — How We Forgot
        </h2>

        <div className="mb-8" data-id="element-50">
          <img src="https://cdn.magicpatterns.com/uploads/gYK19bYupRkcwALzWmCHAX/Dog_resting_in_202604192244_(1).jpg" alt="Dog receiving chemical flea treatment" className="w-full rounded shadow-md" data-id="element-51" />
        </div>

        <div className="font-sans text-lg leading-relaxed text-[#666666] space-y-6" data-id="element-52">
          <p data-id="element-53">
            This is the fall from Eden. The story of how 2,000 years of
            accumulated botanical wisdom was systematically replaced — not
            because it stopped working, but because it couldn't be patented,
            mass-manufactured, or sold at scale by a corporation.
          </p>
          <p data-id="element-54">
            Post-WWII, the same organophosphate chemistry developed as nerve
            agents during the war was repurposed for agricultural and
            residential pest control — and eventually for pet flea and tick
            treatment. The very first synthetic chemical flea collars in the
            1960s were built on this chemistry.
          </p>
          <p data-id="element-55">
            Chemical companies built a distribution pipeline directly through
            the veterinary profession. Vets were trained in a pharmaceutical
            framework — continuing education sponsored by drug companies,
            product samples in every office, commission structures tied to
            prescription products. The message was simple: "Chemical treatments
            are scientific. Plant remedies are folklore."
          </p>
          <p data-id="element-56">
            The displacement wasn't based on evidence that natural methods were
            dangerous — it was based on money, infrastructure, and the fact that
            you can't patent a cedar branch.
          </p>
          <p className="text-2xl font-medium italic text-[#0F4226] my-8 text-center" data-id="element-57">
            "Nobody told you pennyroyal was ineffective. They just stopped
            telling you it existed."
          </p>
        </div>
      </div>
    </motion.section>;
}